import { http } from "../../../utils/http";
import LocalStorageService from "../../../utils/LocalStorageService";
import { persistor } from "../../index";
import { showSuccessSnackbar, showErrorSnackbar } from "../snackbar/index";

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT_SUCCESS,
} from "./types";

const localStorageService = LocalStorageService.getService();
const initialState = { isLoginLoading: false };

export const loginUserRequest = () => ({
  type: LOGIN_REQUEST,
  isLoginLoading: true,
  isLoggedIn: false,
});

export const loginUserSuccess = (response) => ({
  type: LOGIN_SUCCESS,
  isLoggedIn: true,
  isLoginLoading: false,
  response,
});

export const logoutUserSuccess = () => ({
  type: LOGOUT_SUCCESS,
  isLoggedIn: false,
});

export const loginUserFailed = (response) => ({
  type: LOGIN_FAILED,
  isLoggedIn: false,
  isLoginLoading: false,
  response,
});

export const logoutUser = () => (dispatch) => {
  localStorageService.clearToken();
  setTimeout(() => persistor.purge(), 200);
  dispatch(logoutUserSuccess());
  dispatch(showSuccessSnackbar("You have been logged out successfully."));
};

export const loginUser = (userData) => (dispatch) => {
  dispatch(loginUserRequest());
  return http
    .post("/api/users/login/", userData)
    .then((res) => {
      localStorageService.setToken(res.data.user);
      dispatch(loginUserSuccess(res));
      dispatch(showSuccessSnackbar(`Login successful. \n Welcome to HairQ`));
    })
    .catch((errors) => {
      dispatch(loginUserFailed(errors.response?.data.errors));
      console.log("log in errors", errors.response?.data.errors);
      dispatch(
        showErrorSnackbar(
          errors.response?.data.errors.error[0] ??
            "Please check your internet connection"
        )
      );
    });
};

export const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, isLoginLoading: action.isLoginLoading };
    case LOGIN_SUCCESS:
      return {
        ...state,
        response: action.payload,
        isLoggedIn: action.isLoggedIn,
        isLoginLoading: action.isLoginLoading,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        response: action.payload,
        isLoggedIn: action.isLoggedIn,
        isLoginLoading: action.isLoginLoading,
        errors: action.response,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
      };
    default:
      return { ...state };
  }
};

export default loginReducer;
